export class TabLink {
    constructor() {
        this.init();
    }

    init() {
        const roots = document.querySelectorAll('.tabs__link, .staff-tabs');
        if (!roots.length) return;

        function textToSlug(text) {
            return text.trim().toLowerCase().replace(/\s+/g, '-');
        }

        function handleClick(listItem) {
            if (!listItem) return;
            const p = listItem.querySelector('p');
            if (!p) return;
            const slug = textToSlug(p.textContent);
            const url = new URL(window.location);
            url.searchParams.set('tab', slug);
            // Keep FAQ params out of staff/tab deep links.
            url.searchParams.delete('faq_tab');
            url.searchParams.delete('faq_search');
            window.history.pushState({}, '', url);
        }

        document.body.addEventListener('click', (e) => {
            const root = e.target.closest('.tabs__link, .staff-tabs');
            if (!root) return;
            const listItem = e.target.closest('.tabs_list_container > *');
            if (!listItem || !root.contains(listItem)) return;
            handleClick(listItem);
        });

        const currentTab = new URLSearchParams(window.location.search).get('tab');
        if (!currentTab) return;

        const observer = new MutationObserver(() => {
            for (const root of roots) {
                const allItems = root.querySelectorAll('.tabs_list_container > *');
                for (const item of allItems) {
                    const p = item.querySelector('p');
                    if (!p) continue;
                    const slug = textToSlug(p.textContent);
                    if (slug === currentTab) {
                        setTimeout(() => {
                            item.click();
                        }, 210);
                        observer.disconnect();
                        return;
                    }
                }
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
}
